import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function TagEarleyPrefixValidScanEps() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Scan-ε:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>[γ, p, la, i<sub>γ</sub>, i, j, k, l, 0]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[γ, p, ra, i<sub>γ</sub>, i, j, k, l, 0]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>l(γ, p<sub>γ</sub> · p) = ε</span></div>
    </div>)
}
